import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { suggestSalesStrategy } from '../../lib/openai';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiBriefcase, FiLoader } = FiIcons;

function SalesStrategy({ customer }) {
  const [strategy, setStrategy] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const generateStrategy = async () => {
    setIsLoading(true);
    try {
      const result = await suggestSalesStrategy(customer);
      setStrategy(result);
    } catch (error) {
      console.error('Error generating sales strategy:', error);
      setStrategy('Failed to generate sales strategy. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <SafeIcon icon={FiBriefcase} className="w-5 h-5 mr-2 text-primary-500" />
        AI Sales Strategy
      </h3>
      
      <div className="bg-gray-50 p-3 rounded-lg mb-4">
        <div className="grid grid-cols-2 gap-2 text-sm">
          <p className="text-gray-500">Customer:</p>
          <p className="font-medium">{customer.firstName} {customer.lastName}</p>
          
          <p className="text-gray-500">Status:</p>
          <p className="font-medium capitalize">{customer.status}</p>
          
          <p className="text-gray-500">Interest:</p>
          <p className="font-medium">{customer.interestedVehicle || 'Not specified'}</p>
          
          <p className="text-gray-500">Budget:</p>
          <p className="font-medium">{customer.budget ? `$${customer.budget.toLocaleString()}` : 'Not specified'}</p>
        </div>
      </div>
      
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={generateStrategy}
        disabled={isLoading}
        className="w-full bg-primary-600 text-white py-2 rounded-lg font-medium hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2 mb-4 disabled:opacity-50"
      >
        {isLoading ? (
          <>
            <SafeIcon icon={FiLoader} className="w-4 h-4 animate-spin" />
            <span>Generating...</span>
          </>
        ) : (
          <>
            <SafeIcon icon={FiBriefcase} className="w-4 h-4" />
            <span>Generate Sales Strategy</span>
          </>
        )}
      </motion.button>
      
      {strategy && (
        <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
          <h4 className="font-medium text-gray-900 mb-2">Recommended Strategy</h4>
          <p className="text-sm whitespace-pre-wrap">{strategy}</p>
        </div>
      )}
    </div>
  );
}

export default SalesStrategy;